<template>
  <div class="columns">
    <div class="column"></div>
    <div class="column is-5 has-text-centered">
      <div class="card">
        <div
          class="card-header"
          style="padding: 10px; margin-top: 10px; background-color: #eb4b1b;"
        ></div>
        <div class="card-body" style="padding: 15px">
          <h6 class="title is-3">Give us a few seconds...</h6>
          <h6 class="subtitle is-4">There's a lot of data to load!</h6>
          <i class="fa fa-refresh fa-spin fa-4x"></i>
        </div>
        <div
          class="card-footer"
          style="padding: 10px; margin-top: 10px; background-color: #eb4b1b;"
        ></div>
      </div>
    </div>
    <div class="column"></div>
  </div>
</template>

<script>
export default {
  name: 'LoadingBox',
}
</script>

<style></style>
